import { useTranslation } from 'react-i18next';
import { EmptyMessage } from './styles';

const EmptyState = () => {
  const { t } = useTranslation();
  return (
    <EmptyMessage>
      {t('품의를 찾을 수 없어요. 검색어를 다시 확인해 주세요.')}
    </EmptyMessage>
  );
};

export default EmptyState;
